import { render, staticRenderFns } from "./PageEducatorInstitutionRead.vue?vue&type=template&id=aa40e11e&scoped=true&"
import script from "./PageEducatorInstitutionRead.vue?vue&type=script&lang=js&"
export * from "./PageEducatorInstitutionRead.vue?vue&type=script&lang=js&"
import style0 from "./PageEducatorInstitutionRead.vue?vue&type=style&index=0&id=aa40e11e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa40e11e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
